// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [require('ui/web/documentCard').name];

module.exports = angular
  .module('bench.app.dms.other', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.dms.other', {
      url: '/other/:date/:page',
      params: {
        date: {
          value: 'all',
        },
        page: {
          value: '1',
          squash: true,
        },
      },
      controller($stateParams) {
        this.$stateParams = $stateParams;
        return this;
      },
      controllerAs: 'vm',
      template: `\
<div class="other-documents">
  <div
    class="card-wrapper">
    <bl-document-card
      client-id="vm.$stateParams.clientId"
      document-type="NOT_STATEMENT"
      date="vm.$stateParams.date"
      page="vm.$stateParams.page"
      ledger-id="'all'">
    </bl-document-card>
  </div>
</div>\
`,
    }),
  );
